import React, { Component } from 'react';

import { LoginContext } from './LoginContext';
import FormOne from './FormOne';
import FormTwo from './FormTwo';
import ForgotPassword from './ForgotPassword';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: "one",
      context: {
        formData: {
          username: "",
          password: "",
          code: "",
          email: "",
        },
        logo: "https://s3-ap-southeast-2.amazonaws.com/dcnetres/dcNet.png",
        codeRef: React.createRef(),
        changeForm: this.changeForm,
        handleFieldChange: this.handleFieldChange,
      },
    }
  }

  loginPartOne = (event) => {
    event.preventDefault();

    let { username, password } = this.state.context.formData;

    if (username === "" || password === "") {
      return alert("Please enter username and password");
    }

    fetch('/api/login', {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then((res) => {
      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          this.updateFormData("password", "");
          alert("Could not log in!\n\nPossible Reasons:\n1. Incorrect Username or Password\n2. Account has not yet been verified\n3. Account is disabled");
        } else {
          throw Error(res.statusText);
        }
      } else {
        this.changeForm("two");
      }
    }).catch(function(error) {
      console.log(error);
    });
  }

  loginPartTwo = (event) => {
    event.preventDefault();

    let { code } = this.state.context.formData;

    if (code === "") return alert("Please enter authenticator code");

    fetch('/api/loginPartTwo', {
      method: "POST",
      body: JSON.stringify({ code }),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then((res) => {
      if (!res.ok) {
        if (res.status === 401) {
          this.updateFormData("code", "");
          this.state.context.codeRef.current.focus();
          alert("Incorrect code");
        } else {
          throw Error(res.statusText);
        }
      } else {
        res.json().then(({ username }) => this.props.login(username));
      }
    })
    .catch(error => console.log(error));
  }

  submitResetPassword = (event) => {
    event.preventDefault();

    let { username, email, code } = this.state.context.formData;

    if(username === "") return alert("Please enter username");
    if(email === "") return alert("Please enter email");
    if(code === "") return alert("Please enter code");

    fetch('/api/forgotPassword', {
      method: "POST",
      body: JSON.stringify({ username, email, code }),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then((res) => {
      if (!res.ok) {
        this.updateFormData("code", "");
        alert("Could not reset password\n\nPossible Reasons:\n1. Your account is disabled\n2. Incorrect Username or Email\n3. Account has not yet been verified\n4. Incorrect Authenticator code\n\nIf the problem persists, please contact an administrator");
      } else {
        alert("A password reset link has been sent to your email");
        this.changeForm("one");
      }
    }).catch(function(error) {
      alert("Could not reset password");
      console.log(error);
    });
  }

  changeForm = (view) => {
    let context = this.state.context;
    context.formData = {
      username: "",
      password: "",
      code: "",
      email: "",
    };

    this.setState({ view, context });
  }

  updateFormData = (field, value) => {
    let context = this.state.context;
    context.formData[field] = value;
    this.setState({ context });
  }

  handleFieldChange = (event) => {
    this.updateFormData(event.target.name, event.target.value);
  }

  render() {
    let view;
    switch (this.state.view) {
      case "one":
        view = <FormOne submit={this.loginPartOne} />;
        break;
      case "two":
        view = <FormTwo submit={this.loginPartTwo} />;
        break;
      case "forgotPassword":
        view = <ForgotPassword submit={this.submitResetPassword} />
        break;
      default:
        view = <FormOne submit={this.loginPartOne} />;
        break;
    }

    return (
      <LoginContext.Provider value={this.state.context}>
        {view}
      </LoginContext.Provider>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Login/Login.js